import { createSelector } from 'reselect';
import { RootState } from 'src/store/store';

export const selectSupportTicketTemplates = (state: RootState) => state.xptAppMetadataStore.parsedMetadata.xpt_tt_templates;

export const selectGeneralSupportLink = createSelector(
  [selectSupportTicketTemplates],
  (supportTemplates) => supportTemplates?.fixedTickets.find((tt) => tt.name === 'xPT App Support')?.url
);
